import { PocCard } from 'commons/components/components-wrapper/poc-card.component';
import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const CustomNotificationFormContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    padding: 24px;
    overflow: auto;
    background-color: ${owcTheme['one-color-gray-50']};
`;

export const CustomNotificationFormCard = styled(PocCard)`
    width: 100%;
    max-width: 600px;
`;

export const CustomNotificationFormCardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
`;
